import { lazy, type ComponentType } from "react";

/**
 * React.lazy resiliente a deploys novos.
 *
 * Depois de uma publicação, os arquivos antigos do site deixam de existir.
 * Se a aba do usuário ainda tem a versão antiga carregada, o import dinâmico
 * falha e a tela de erro aparece. Aqui tentamos de novo e, se persistir,
 * recarregamos a página uma única vez para buscar a versão nova.
 */
export function lazyRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
  key: string,
) {
  return lazy(async () => {
    const flag = `chunk-reloaded:${key}`;
    try {
      const mod = await factory();
      if (!mod || !mod.default) throw new Error("Módulo vazio");
      sessionStorage.removeItem(flag);
      return mod;
    } catch (err) {
      // Segunda tentativa (falha momentânea de rede)
      try {
        await new Promise((r) => setTimeout(r, 600));
        const mod = await factory();
        if (!mod || !mod.default) throw new Error("Módulo vazio");
        sessionStorage.removeItem(flag);
        return mod;
      } catch (err2) {
        const alreadyReloaded = sessionStorage.getItem(flag) === "1";
        if (!alreadyReloaded && typeof window !== "undefined") {
          sessionStorage.setItem(flag, "1");
          window.location.reload();
          // Evita que o erro suba antes do reload acontecer
          return new Promise<{ default: T }>(() => {});
        }
        throw err2;
      }
    }
  });
}
